import { BeneficiaryRelationshipOptions } from 'src/constants/beneficiary-relationship';
import { US_STATES } from 'src/constants/us-states';

export const RELATIONSHIP_SELECT_ITEMS = BeneficiaryRelationshipOptions.map((option) => ({
  value: option.value,
  label: option.label,
}));

const TRUST_TYPE_OPTIONS = ['Revocable', 'Irrevocable', 'Testamentary', 'Other'] as const;
const ORGANIZATION_TYPE_OPTIONS = ['LLC', 'S-Corp', 'C-Corp', 'Partnership', 'Other'] as const;

// Base UI's Select reads `items` to render the chosen value as its label; without it the trigger
// shows the raw stored value.
export const TRUST_TYPE_SELECT_ITEMS = TRUST_TYPE_OPTIONS.map((value) => ({ value, label: value }));
export const ORGANIZATION_TYPE_SELECT_ITEMS = ORGANIZATION_TYPE_OPTIONS.map((value) => ({ value, label: value }));
export const US_STATE_SELECT_ITEMS = US_STATES.map((usState) => ({ value: usState.label, label: usState.label }));

export const ROLE_FIELDS = [
  {
    name: 'isBeneficiary',
    label: 'Beneficiary',
    description: 'Named to inherit household assets',
  },
  {
    name: 'isDependent',
    label: 'Dependent',
    description: 'Financially dependent on a client',
  },
  {
    name: 'isTrustedContact',
    label: 'Trusted contact',
    description: 'Authorized point of contact',
  },
] as const;

/**
 * Encodes which of the two mutually exclusive `dependentOf*` columns a Select option writes. The
 * combined "both clients" option is the household row — clients are users on the household, so
 * there is no pair-of-users target.
 */
export const DEPENDENT_TARGET_PREFIX = {
  household: 'household:',
  user: 'user:',
} as const;

/**
 * "Dependent, nobody in particular" is a valid state, so it needs a real option rather than an
 * unselected Select — otherwise a target that has been chosen once can never be taken back.
 */
export const DEPENDENT_TARGET_NONE = 'none';

/**
 * The Select opens on this so its placeholder shows and picking a target reads as a deliberate act,
 * rather than defaulting to the "No specific person" option. Decodes to no target, same as NONE.
 */
export const DEPENDENT_TARGET_UNSET = '';
